<template>
    <div id="fileupload">
          <el-upload
            v-if="$store.state.shopId!=''&&$store.state.shopId&&$store.state.shopId!=null&&$store.state.shopId!=undefined"
            class="upload-demo"
            :action="address"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :before-remove="beforeRemove"
            multiple
            name='import'
            :limit="1"
            :on-exceed="handleExceed"          
            :on-success='isOk'
            :before-upload='beforeUpload'
            :file-list="fileList">
            <el-button type="primary">点击批量上传课程</el-button>
            <div slot="tip" class="el-upload__tip">只能上传zip格式压缩文件</div>   
          </el-upload>
          <div class="upload-demo">
            <el-upload
            v-if="$store.state.shopId!=''&&$store.state.shopId&&$store.state.shopId!=null&&$store.state.shopId!=undefined"
            :action="addressTwo"
            :on-preview="handlePreviewTwo"
            :on-remove="handleRemoveTwo"
            :before-remove="beforeRemoveTwo"
            multiple
            name='excel_file'
            :limit="1"
            :on-exceed="handleExceedTwo"          
            :on-success='isOkTwo'
            :before-upload='beforeUploadTwo'
            :file-list="fileListTwo">
            <el-button type="primary">点击批量注册用户</el-button>
            <div slot="tip" class="el-upload__tip">只能上传excel文件的xlsx</div>
          </el-upload>
          <a :href="this.download" class="uk-button uk-button-primary">下载批量注册用户excel模板</a>
          </div>
          
    </div>
</template>
<script>
  export default {
    data() {
      return {
        fileList: [],
        fileListTwo:[],
        address:this.baseUrl+'file/import_products?token='+this.$store.state.id,
        addressTwo:this.baseUrl+'file/import_users?token='+this.$store.state.id,
        download:this.baseUrl+'excel/excel_template.xlsx',

      };
    },
    methods: {
      beforeUpload(file){
        let str=file.name;
        // // console.log(file);
        if(str.substr(str.length - 3, 3).toLocaleLowerCase() != "zip"){
          alert('压缩文件必须是zip格式')
          return false;
        }
      },
      handleRemove(file, fileList) {
        // // console.log(file, fileList);
      },
      handlePreview(file) {
        // // console.log(file);
      },
      handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      beforeRemove(file, fileList) {
        return this.$confirm(`确定移除 ${ file.name }？`);
      },
      isOk(response, file, fileList){
        alert(response.msg);
      },


      beforeUploadTwo(file){
        let str=file.name;
        // // console.log(file);
        if(str.substr(str.length - 4, 4).toLocaleLowerCase() != "xlsx"){
          alert('excel文件必须是xlsx格式')
          return false;
        }
      },
      handleRemoveTwo(file, fileList) {
        // // console.log(file, fileList);
      },
      handlePreviewTwo(file) {
        // // console.log(file);
      },
      handleExceedTwo(files, fileList) {
        this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      beforeRemoveTwo(file, fileList) {
        return this.$confirm(`确定移除 ${ file.name }？`);
      },
      isOkTwo(response, file, fileList){
        alert(response);
      },
      
    }
  }
</script>
<style scoped>
    .upload-demo{
        width: 70%;
        margin:80px auto 0px;
        background-color: gainsboro;
    }
</style>
